import { tryParseJson } from '../utils/utils';

const toStringOrUndefined = (obj: any) => {
  return obj && `${obj}`;
};

const toNameValue = (obj: any) => {
  if (typeof obj === 'object' && typeof obj?.name === 'string') {
    return obj.name;
  }
  return obj;
};

export const translatePageData = (pageData?: string | object) => {
  if (!pageData) {
    return;
  }

  const parsedPageData = tryParseJson(pageData);
  const { id, vin, title, listingTitlePSX, year, make, model, trim, consumerId, owner = {}, pricingDetail = {}, financingTypePSX = '' } = parsedPageData;
  const { id: ownerId, name, location } = owner;
  const { salePrice } = pricingDetail;

  const data = {
    listing: {
      id: toStringOrUndefined(id),
      vin,
      title,
      listingTitlePSX,
      year,
      make: toNameValue(make),
      model: toNameValue(model),
      trim: toNameValue(trim),
      location,
      salePrice,
      financingTypePSX,
    },
    seller: {
      id: toStringOrUndefined(ownerId),
      consumerId: toStringOrUndefined(consumerId),
      name,
    },
    clientUser: {},
  };

  return data;
};
